
import { mapState } from 'vuex'
import form from '@/utils/form'

import AccordionContainer from '@/components/AccordionContainer'
import InputField from '@/components/InputField'
import HeroButton from '@/components/HeroButton'
import Message from '@/components/Message'

import TickIcon from '@/static/svg/prescription/tick-icon.svg'
import SmallMessage from '@/components/layouts/SmallMessage'

export default {
  components: {
    SmallMessage,
    AccordionContainer,
    InputField,
    HeroButton,
    TickIcon,
    Message,
  },
  props: {
    coupon: {
      type: String,
      default: '',
    },
    couponDetails: {
      type: Object,
      default: () => ({}),
    },
    error: {
      type: Object,
      default: () => ({}),
    },
    showBorder: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      promoExpanded: false,
      form: form({ coupon: { validation: 'onSubmit', value: '' } }),
    }
  },
  computed: {
    ...mapState(['arSetupOrderCouponCode']),
    ...mapState('order', ['autoReorderDaysInterval']),
    autoReorderSetupDiscountApplied() {
      return (
        !!this.couponDetails.code &&
        !!this.arSetupOrderCouponCode &&
        this.couponDetails.code.toLowerCase() === this.arSetupOrderCouponCode.toLowerCase()
      )
    },
    showCouponInput() {
      return !this.couponDetails.code || this.autoReorderSetupDiscountApplied
    },
  },
  watch: {
    autoReorderDaysInterval: {
      handler(newVal, oldVal) {
        if (!this.arSetupOrderCouponCode) {
          return
        }
        const autoReorderNewlyEnabled = !oldVal && newVal
        const autoReorderNewlyDisabled = !newVal && oldVal
        const aCouponCodeIsSet = !!this.couponDetails.code

        if (autoReorderNewlyEnabled && !aCouponCodeIsSet) {
          this.applyAutoReorderSetupCode()
        } else if (autoReorderNewlyDisabled && this.autoReorderSetupDiscountApplied) {
          this.removePromo()
        }
      },
    },
  },
  methods: {
    closeAccordion() {
      this.promoExpanded = false
    },
    togglePromo() {
      this.promoExpanded = !this.promoExpanded
      if (this.promoExpanded) {
        this.$emit('expanded')
      }
    },
    submit() {
      this.form.validate()

      if (this.form.isValid()) {
        const { coupon } = this.form.getValues()
        this.form.coupon.value = ''
        this.$emit('code-applied', coupon)
      }
    },
    validate(field) {
      this.form.validateField(field)
    },
    removePromo() {
      // If the arSetup coupon code exists and auto reorder is set up, apply it instead of removing
      if (this.arSetupOrderCouponCode && this.autoReorderDaysInterval) {
        this.applyAutoReorderSetupCode()
        return
      }

      // standard behaviour, remove the coupon code
      this.form.coupon.value = ''
      this.$emit('code-removed')
    },
    applyAutoReorderSetupCode() {
      this.$emit('code-applied', this.arSetupOrderCouponCode)
    },
  },
}
